import { usePostPortfolioServicesMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioServicesMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { SERVICES_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormDefaults";
import { getServicesFormSchema } from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormSchema";
import { mapServicesFormToCreateRequest } from "web_myplann/Portfolio/Forms/ServicesForm/servicesRequestPayload";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateServicesForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioServicesMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getServicesFormSchema(t, { isCreate: true }),
		defaultValues: SERVICES_FORM_DEFAULT_VALUES,
		mutate: (values, options) =>
			mutate(mapServicesFormToCreateRequest(values), options),
		successRoute: Routing.Portfolio.PortfolioAddServicesSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
